// Module
var code = "<div class=\"ui segment fourohfour\"> <div class=\"content\"> <h2 translate=\"{{'404.404'}}\"></h2> <p>{{ 'fourOhFour.canNotBeFound' | translate }}</p> <span translate=\"{{'404.go_to_help'}}\"></span> </div> <div class=\"logo\"></div> </div> ";
// Exports
module.exports = code;